const _ = require('lodash');

let _api, _specialsGroupProductsApi, _hyphenate, _specialGroupsPromise, _state, _firstSpecialsGroup;

function SpecialsGroupsService(restangular, $rootScope, $q, hyphenate, shopperService, $state, bootstrap) {
    // Apis
    _api = restangular.all('SpecialsGroupsForShop');
    _specialsGroupProductsApi = restangular.all('Product');

    // Private variables
    _hyphenate = hyphenate;
    _specialGroupsPromise = null;
    _firstSpecialsGroup = null;
    _state = $state;
    this.allSpecials = 'All Specials';
    this.mySpecials = 'My Specials';
    const self = this;
    self.allSpecialsGroup = {};
    self.shopperService = shopperService;
    self.specialViewType = 'Type';

    $rootScope.$on('address-update', function () { this.invalidateSpecialGroups(); }.bind(this));

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SpecialsGroups)) {
        _specialGroupsPromise = $q
            .when(bootstrap.getBootstrappedData(bootstrap.bootstrapped.SpecialsGroups))
            .then(this._setGroups.bind(this, null));
    }
}

SpecialsGroupsService.prototype._setGroups = function (currentSpecialsGroup, groups) {
    this.selectedGroup = currentSpecialsGroup;
    groups = this.removeEmptyYourSpecials(groups);
    _firstSpecialsGroup = groups[0].Name;
    return groups;
};

SpecialsGroupsService.prototype.removeEmptyYourSpecials = function (groups) {
    // For Authenticated user if the 'Your Specials' doesn't have any items then do not display it.
    if (!this.shopperService.currentUser.isGuest && groups[0].ProductCount === 0) {
        groups.splice(0, 1);
    }
    return groups;
};

SpecialsGroupsService.prototype.listGroups = function () {
    if (!_specialGroupsPromise) {
        const currentSpecialsGroup = this.selectedGroup;
        this.selectedGroup = null;
        _specialGroupsPromise = _api.getList().then(this._setGroups.bind(this, currentSpecialsGroup));
    }

    return _specialGroupsPromise;
};

SpecialsGroupsService.prototype.selectGroupByName = function (specialGroupName) {
    const self = this;
    const promise = this.listGroups().then(function (groups) {
        return self.findSpecialsGroup(groups, specialGroupName);
    });
    return promise.then(function (maybeSpecialsGroup) {
        if (maybeSpecialsGroup) {
            this.selectGroup(maybeSpecialsGroup);
        }

        return maybeSpecialsGroup;
    }.bind(this));
};

SpecialsGroupsService.prototype.findSpecialsGroup = function (groups, specialGroupName) {
    return _.find(groups, function (group) {
        return _hyphenate(group.Name) === specialGroupName;
    });
};

SpecialsGroupsService.prototype.selectGroup = function (specialsGroup) {
    this.selectedGroup = specialsGroup;
};

SpecialsGroupsService.prototype.isAllSpecialsSelected = function () {
    return !!this.selectedGroup && this.selectedGroup.Name === this.allSpecials;
};

SpecialsGroupsService.prototype.isMySpecialsSelected = function () {
    return !!this.selectedGroup && this.selectedGroup.Name === this.mySpecials;
};

function createArgs(args, includeGroupId) {
    const result = {
        pageNumber: args.pageNumber,
        pageSize: args.pageSize || 10,
        sortType: args.sortType
    };
    if (includeGroupId) {
        result.GroupID = args.specialsGroup.ID;
    }
    return result;
}

SpecialsGroupsService.prototype.getAllSpecialsProducts = function (args) {
    return _specialsGroupProductsApi
        .doGET('Specials', createArgs(args, false))
        .then(function (response) {
            return {
                totalRecordCount: response.TotalRecordCount,
                items: response.Items
            };
        });
};

SpecialsGroupsService.prototype.getProducts = function (args) {
    return _specialsGroupProductsApi
        .one('Specials', _hyphenate(args.specialsGroup.Name))
        .get(createArgs(args, true))
        .then(function (response) {
            return {
                totalRecordCount: response.TotalRecordCount,
                items: response.Items
            };
        });
};

SpecialsGroupsService.prototype.updateUrl = function () {
    if (_state.includes('shop.specials.groups') || _state.includes('shop.specials.groupsv2')) {
        if (!_state.params.specialGroup) {
            this.firstSpecialsGroupUrl();
        }
    }
};

SpecialsGroupsService.prototype.gotToFistSpecialsGroup = function () {
    const self = this;

    if (!_specialGroupsPromise) {
        _specialGroupsPromise = _api.getList().then(function (groups) {
            groups = self.removeEmptyYourSpecials(groups);
            _firstSpecialsGroup = groups[0].Name;
            self._setGroups.bind(self, groups[0]);
            _state.go('shop.specials.groups', { specialGroup: _hyphenate(_firstSpecialsGroup) }, { location: 'replace' });
        });
    } else {
        _state.go('shop.specials.groups', { specialGroup: _hyphenate(_firstSpecialsGroup) }, { location: 'replace' });
    }

    return _specialGroupsPromise;
};

SpecialsGroupsService.prototype.firstSpecialsGroupUrl = function () {
    _state.go('shop.specials.groups', { specialGroup: _hyphenate(_firstSpecialsGroup) }, { location: 'replace' });
};

SpecialsGroupsService.prototype.invalidateSpecialGroups = function () {
    _specialGroupsPromise = null;
};
module.exports = SpecialsGroupsService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/specials-groups-service.js
 **/